var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseEmailPart',_vm._b({staticClass:"part-inner-container"},'BaseEmailPart',_vm.$attrs,false),[_c('p',[_c('span',[_vm._v(_vm._s(_vm.date))])])])}
var staticRenderFns = []

export { render, staticRenderFns }